export default {
  // Toolbar
  toolbar: {
    searchPlaceholder: "Пребарај примероци",
    refreshTooltip: "Освежи примероци",
    filterTooltip: "Филтрирај примероци",

    tabs: {
      samples: "Примероци",
      visits: "Визити",
    },
  },

  // Sample list
  samples: {
    title: "Примероци",
    noSamples: "Моментално нема достапни примероци.",
    noSamplesSubtitle: "Примероците ќе се појават тука кога ќе бидат подготвени за валидација.",
    refreshSamples: "Освежи",
    noSamplesMatchFilters: "Нема примероци што одговараат на филтрите",
    clearFilters: "Променете филтри",
    error404: "API крајната точка не е пронајдена (404). Проверете ја конфигурацијата.",
    error500: "Серверска грешка (500). Обидете се повторно подоцна.",
    errorAuth: "Грешка при автентикација. Најавете се повторно.",
    errorNetwork: "Мрежна грешка. Проверете ја интернет конекцијата.",
    noResults: 'Не се најдени примероци за "{query}"',
    errorLoading: "Се појави грешка при вчитувањето на примероците.",
    retry: "Повторен обид",

    actions: {
      highPriority: "Итно",
      more: "Повеќе акции",
      edit: {
        title: "Уреди баркод",
        description: "Промени го баркодот за овој примерок.",
      },
      info: {
        title: "Информации за примерок",
        description: "Преглед на детали за примерокот",
      },
      rejectAll: {
        title: "Отфрлање на сите резултати",
        description: "Отфрлање на сите резултати на чекање за овој примерок.",
      },
    },
  },

  // Patient info
  patient: {
    dateOfBirth: "Датум на раѓање",
    male: "М",
    female: "Ж",
  },

  // Visit info
  visit: {
    tooltips: {
      visitId: "ID на визита",
      visitDate: "Датум на визита",
      visitCategory: "Категорија на визита",
      visitLocation: "Локација на визита",
      requester: "Побарувач",
      notes: "Белешка за визита",
      doctor: "Лекар",
    },
  },

  // Results
  results: {
    noDataAvailable: "Нема достапни податоци",
    noDataAvailableSubtitle: "Оваа проба нема резултати или информации за посета.",
    edited: "уредено",
    viewEditHistory: "Кликнете за да ја видите историјата на уредувањата",
    pending: {
      title: "Резултати на чекање",
      rejectAll: "Отфрлање на сè",
      acceptAll: "Прифаќање на сè",
      reject: "Отфрлање",
      accept: "Прифаќање",
      addAndAccept: "Додавање и прифаќање",
      moreActions: "Повеќе акции",
      expand: "Проширување на сè",
      collapse: "Свиткување на сè",
      viewHistory: "Историја",
      viewHistoryDescription: "Преглед на историја на пациентот за овој тест.",
      flagsDescription: "Преглед на ознаки поврзани со овој резултат.",
      rejectDescription: "Отфрлање на резултат",
      editDescription: "Уредување на резултат",

      acceptSuccess: "Резултатот е успешно прифатен",
      acceptError: "Неуспешно прифаќање на резултатот",
      acceptAllSuccess: "Сите резултати се прифатени",
      acceptAllError: "Неуспешно прифаќање на сите резултати",
      rejectSuccess: "Резултатот е отфрлен",
      rejectError: "Неуспешно отфрлање на резултатот",
      rejectAllSuccess: "Сите резултати се отфрлени",
      rejectAllError: "Неуспешно отфрлање на сите резултати",
      resultTimeTooltip: "Време на изработка на резултат од инструмент",
      errors: {
        networkError: "Мрежна грешка. Проверете ја вашата интернет конекција.",
        serverError: "Серверска грешка. Ве молиме обидете се повторно подоцна.",
        loadingFailed: "Неуспешно вчитување на резултати. Ве молиме обидете се повторно.",
        pleaseTryAgain: "Ве молиме обидете се повторно.",
        nonDeterministicProfile:
          "Профилот на резултатот не е детерминистички. Ве молиме контактирајте го администраторот.",
      },
    },
    current: {
      title: "Тековни резултати",
      resultTimeTooltip: "Време на валидација и публикување во LIS",
    },
    editedIndicator: "Овој резултат е рачно изменет",
    editTooltip: {
      previousValue: "Претходна вредност",
      editedBy: "Изменето од",
      editedAt: "Изменето на",
    },
    refRange: "Реф. опсег",
    viewHistory: "Преглед на историја на пациентот",
    loadingData: "Вчитување на податоци...",
  },

  flags: {
    descriptions: {
      0: "Неизвестно",
      1: "Значително под референтниот диапазон",
      2: "Под референтниот диапазон",
      3: "Леко под нормата",
      4: "Во нормални граници",
      5: "Леко над нормата",
      6: "Над референтниот диапазон",
      7: "Критично високо ниво",
    },
  },

  // Alerts
  alerts: {
    visitMissing: {
      title: "Недостасуваат информации за визита",
      message: "Нема информации за визита поврзани со овој примерок.",
    },
    noResults: {
      title: "Не се најдени резултати",
      message: "Нема резултати поврзани со овој примерок.",
    },
    flaggingMissing: {
      title: "Недостасуваат информации за означување",
      message: "Нема информации за означување поврзани со овој примерок.",
    },
  },

  // Dialogs
  dialogs: {
    // Edit Sample Dialog
    editSample: {
      title: "Уреди баркод на примерок",
      subtitle: "Баркод: {barcode} / {type}",
      saveBarcode: "Уреди",
      description: "Го уредувате баркодот за примерок: <strong>{barcode}</strong>",
      newBarcodeLabel: "Нов баркод",
      hint: "Баркодот може да содржи само букви, броеви, црта (-) и долна црта (_)",
      errors: {
        required: "Баркодот е задолжителен",
        barcodeExists: "Примерок со овој баркод веќе постои",
        containsQuotes: "Баркодот не може да содржи наводници (' или \")",
        containsBackslash: "Баркодот не може да содржи обратна коса црта (\\)",
        containsSpecialChars: "Баркодот не може да содржи специјални знаци (нов ред, табулација)",
        invalidCharacters: "Баркодот може да содржи само букви, броеви, црта (-) и долна црта (_)",
        networkError: "Грешка во мрежата - обидете се повторно",
      },
      success: "Баркодот на примерокот е успешно ажуриран",
      error: "Неуспешно ажурирање на баркодот на примерокот",
    },

    // Edit Result Dialog
    editResult: {
      title: "Уреди резултат",
      subtitle_test: "Код на тест",
      subtitle_id: "ID на резултат",
      fields: {
        testName: "Име на тестот",
        originalResult: "Оригинален резултат",
        newResult: "Нов резултат",
        reason: "Причина за промена (опционално)",
        reasonPlaceholder: "на пр., Коригирана инструментална грешка, Рачно преизчислување",
        units: "Единици",
        range: "Референтен опсег",
        resultTime: "Датум / Време",
      },
      preview: {
        title: "Парсирана вредност",
        parsed: "Ќе се зачува како",
      },
      changePreview: "Промена",
      validation: {
        required: "Полето е задолжително",
        invalidNumeric: "Внесете валидна нумеричка вредност",
        belowRange: "Под опсегот: {range}",
        aboveRange: "Над опсегот: {range}",
        withinRange: "Во опсегот: {range}",
      },
      success: "Резултатот е успешно ажуриран",
      error: "Неуспешно ажурирање на резултатот",
    },

    // Sample Info Dialog
    sampleInfo: {
      subtitle_type: "Тип примерок",
      subtitle_visit: "Посета",
      subtitle_results: "Резултати",
    },

    // Filter Samples Dialog
    filterSamples: {
      title: "Филтрирај примероци",
      subtitle_none: "Нема активни филтри — прикажани се сите чекачки примероци",
      subtitle_one: "1 активен филтер",
      subtitle_many: "{n} активни филтри",
      unsaved: {
        title: "Незачувани промени",
        message: "Направивте промени на филтрите кои сè уште не се применети. Да ги отфрлиме и да затвориме?",
        stay: "Назад кон филтрите",
        applyAndContinue: "Примени и продолжи",
        discard: "Отфрли промени",
      },
      priority: {
        label: "Приоритет: {status}",
        stat: "само итни",
        all: "сите примероци",
        hint_off:
          "Прикажани се сите чекачки примероци. Вклучете за да ја ограничите листата само на итни (STAT) примероци.",
        hint_on:
          "Прикажани се само итни (STAT) примероци — резултати кои бараат непосредна ревизија пред рутинската работа. Исклучете за да ги прикажете сите примероци.",
      },
      fields: {
        locations: "Локации",
        locations_hint:
          "Локацијата е лабораториска просторија или оддел во кој се групирани инструментите. Ја ограничува листата на примероци од инструментите во избраните простории.",
        instruments: "Инструменти",
        instruments_hint:
          "Ја ограничува листата на примероци примени од конкретни анализатори. Корисно при прегледување на резултатите од еден уред или при истрага на специфичен инструмент.",
        sampleTypes: "Типови на примероци",
        sampleTypes_hint:
          "Материјалот подложен на анализа — на пр. серум, урина, цела крв. Ја ограничува листата на примероци од избраниот тип материјал.",
        visitTypes: "Типови на визити",
        visitTypes_hint:
          "Го класифицира клиничкиот контакт — на пр. итен, амбулантски, болнички. Ја ограничува листата на примероци од избраните видови визити.",
        requesters: "Побарувачи",
        requesters_hint:
          "Одделот или клиниката која ги нарачала испитувањата. Ја ограничува листата на примероци нарачани од избраните одделу или единици.",
        doctors: "Лекари",
        doctors_hint:
          "Лекарот кој ги нарачал испитувањата. Ја ограничува листата на примероци нарачани од избраните лекари.",
      },
    },

    // Patient History Dialog
    patientHistory: {
      title: "Историја на пациентот - {testName}",
      subtitle: "{count} историски резултат | {count} историски резултати",
      loading: "Вчитување на историја на пациентот...",
      noHistory: "Не се најдени историски резултати за овој тест",
      range: "Опсег: {range}",

      tabs: {
        data: "Податоци",
        chart: "Графикон",
      },

      table: {
        visitId: "ID на визита",
        resultTime: "Датум / Време",
        result: "Резултат",
      },

      chart: {
        results: "Резултати",
        normalRange: "Нормален опсег",
        currentVisit: "Тековна визита",
        current: "Тековен",
        date: "Датум",
        value: "Вредност",
        alertTitle: "Графиконот е во развој",
        alertMessage: "Функцијата за графикон е сè уште во процес на развој и наскоро ќе биде достапна.",
      },
    },

    // Reject All Dialog
    rejectAll: {
      title: "Отфрлање на сите резултати",
      subtitle: "Примерок: {barcode} / {type}",
      warning: "Сите резултати на чекање поврзани со овој примерок ќе бидат трајно избришани.",
      confirm: "Отфрлање на сите резултати",
    },

    // Reject Result Dialog
    rejectResult: {
      title: "Отфрлање на резултат",
      subtitle: "Тест: {testName}",
      resultLabel: "Резултат",
      currentValueLabel: "Тековен резултат",
      unitsLabel: "Единици",
      referenceRangeLabel: "Реф. опсег",
      sampleTypeLabel: "Вид примерок",
      resultTimeLabel: "Датум / Време",
      currentValue: "Тековна вредност: {value}",
      warning: "Овој резултат ќе биде трајно избришан од редицата за валидација.",
      confirm: "Отфрли резултат",
    },

    flags: {
      title: "Ознаки",
      subtitle: "Апаратни и неапаратни ознаки, прикачени кон овој резултат.",
      headers: {
        level: "Ниво",
        source: "Извор",
        code: "Код",
        description: "Опис",
      },
      empty: "Нема ознаки поврзани со овој резултат.",
      sources: {
        Instrument: "Апаратна ознака",
        Processor: "Неапаратна ознака",
      },
      levels: {
        0: "Неизвестно",
        1: "Информација",
        2: "Предупредување",
        3: "Грешка",
        4: "Критично",
      },
    },
  },

  signalr: {
    connected: "Активни ажурирања во реално време",
    disconnected: "Ажурирањата во реално време се исклучени",
    reconnecting: "Поврзување повторно со ажурирања во реално време...",
    barcodeChanged: "Баркодот е променет: {old} → {new}",
    connectionFailed:
      "Неуспешна конекција со SignalR по {attempts} обиди. Страницата ќе работи, но без ажурирања во реално време.",
    resultsAdded: "{count} нови резултати за {barcode}",
    resultsDeleted: "{count} избришани резултати за {barcode}",
    resultsModified: "{count} изменети резултати за {barcode}",
    sampleAdded: "Нов примерок со баркод: {barcode} е додаден",
    sampleRemoved: "Примерокот {barcode} беше отстранет",
  },
};
